import { useEffect, useState } from "react";

// Tracks whether the page has been scrolled past `threshold`, used to
// switch the sticky header from transparent to a blurred surface.
export const useScrolled = (threshold = 24) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return scrolled;
};
